import script from "./TreeListMulti.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeListMulti.vue?vue&type=script&lang=ts&setup=true"

import "./TreeListMulti.vue?vue&type=style&index=0&id=52fb0502&lang=css"

const __exports__ = script;

export default __exports__